import React from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function Highdemandslider() {
  return (
    <section className="high_demand_slider p-100">
      <Container>
        <Row>
          <Col xs={12} md={9} lg={8} xl={8} xxl={8}>
            <h2>
              Ease-Up Navigation & Usability with <span>High-Demand App</span>{" "}
              Features
            </h2>
            <p>
              Being a tech-focused and user-centric on demand app development
              company, we build mobile applications that users love to interact
              with. Be it a telemedicine app development or an online grocery
              store creation, our experienced mobile app developers integrate
              best-in-class, essential features for optimal accessibility and
              performance.
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              // autoplay={{
              //   delay: 3000,
              //   disableOnInteraction: false,
              // }}
              autoplay={false}
              modules={[Autoplay, Pagination]}
              pagination={{
                clickable: true,
              }}
              className="high_on_demand_slider"
            >
              <SwiperSlide>
                <Row>
                  <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                    <div className="demand_item">
                      <h5>Seamless Onboarding</h5>
                      <p>
                        Simplify user registration with quick, intuitive
                        onboarding processes.
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                    <div className="demand_item">
                      <h5>Social Sharing</h5>
                      <p>
                        Enable social media sign-up and easy sharing of app
                        content across social media platforms.
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                    <div className="demand_item">
                      <h5>Voice Command Integration</h5>
                      <p>
                        Enhance accessibility with voice-activated commands and
                        controls.
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                    <div className="demand_item">
                      <h5>Biometric Authentication</h5>
                      <p>
                        Increase security with fingerprint or facial recognition
                        for user login.
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                    <div className="demand_item">
                      <h5>One-Click Ordering</h5>
                      <p>
                        Streamline purchases with a single click for faster
                        transactions.
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                    <div className="demand_item">
                      <h5>Augmented Reality Features</h5>
                      <p>
                        Offer immersive AR experiences for product
                        visualization.
                      </p>
                    </div>
                  </Col>
                </Row>
              </SwiperSlide>
              <SwiperSlide>
                <Row>
                  <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                    <div className="demand_item">
                      <h5>Personalized Recommendations</h5>
                      <p>
                        Use AI to deliver tailored content and product
                        suggestions.
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                    <div className="demand_item">
                      <h5>Live Tracking of Services</h5>
                      <p>
                        Provide real-time updates on service status and
                        delivery.
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                    <div className="demand_item">
                      <h5>Offline Mode</h5>
                      <p>
                        Ensure app functionality without internet connectivity.
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                    <div className="demand_item">
                      <h5>In-App Video Calls</h5>
                      <p>
                        Facilitate direct video communication within the app.
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                    <div className="demand_item">
                      <h5>Real-Time Customer Ratings</h5>
                      <p>Allow instant feedback to improve service quality.</p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                    <div className="demand_item">
                      <h5>Zero Trust Security</h5>
                      <p>
                        Implement strict security protocols to protect user
                        data.
                      </p>
                    </div>
                  </Col>
                </Row>
              </SwiperSlide>
              <SwiperSlide>
                <Row>
                  <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                    <div className="demand_item">
                      <h5>Multi-Factor Authentication</h5>
                      <p>
                        Enhance login security with multiple verification steps.
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                    <div className="demand_item">
                      <h5>Contactless Payments</h5>
                      <p>Support secure, touch-free payment methods.</p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                    <div className="demand_item">
                      <h5>Sustainability Metrics</h5>
                      <p>
                        Track and display eco-friendly practices and impact.
                      </p>
                    </div>
                  </Col>
                </Row>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Highdemandslider;
